import React, { useState } from 'react';
import styles from '../../business-division.module.scss';
import IdeaSvg from '/public/landings/assets/icons/business-division/idea';
import SettingsSvg from '/public/landings/assets/icons/business-division/settings';
import LaptopSvg from '/public/landings/assets/icons/business-division/laptop';
import MarketSvg from '/public/landings/assets/icons/business-division/market';
import StarSvg from '/public/landings/assets/icons/business-division/star';
import CodeChatSvg from '/public/landings/assets/icons/business-division/code-chat';
import { properties as cases } from "../../../../../data/successCases";

const productIconsMap = {
    idea: <IdeaSvg />,
    settings: <SettingsSvg />,
    laptop: <LaptopSvg />,
    market: <MarketSvg />,
    star: <StarSvg />,
    'code-chat': <CodeChatSvg />
}

const Products = ({ id, products, selectedLanguage }) => {
    const [selectedProduct, setSelectedProduct] = useState(products && products.length ? products[0] : null);

    const getCase = (id) => {
        return cases.find(c => c?.id === id);
    }

    const selectedCase = getCase(selectedProduct?.about);

    return (
        <section className={styles.businessDivisionProductsContainer}>
            <nav className={styles.businessDivisionProductsNav}>
                <ul>
                    {products?.map((p,i) => (
                        <li key={i} onClick={() => setSelectedProduct(p)}
                            className={`${selectedProduct === p 
                                    ? `${styles[id]} ${styles.selectedProduct}`
                                    : `${styles[`color-${id}`]} ${styles[`fill-${id}`]}`
                                }`}>
                            {productIconsMap[p.icon]}
                            <span>{p.name[selectedLanguage]}</span>
                        </li>
                    ))}
                </ul>
            </nav>
            <div className={`${styles.businessDivisionProductDetailsContainer} ${styles[selectedProduct?.id]}`}>
                <div className={`${styles.businessDivisionProductDetails} ${styles[`fill-${id}`]}`}>
                    {productIconsMap[selectedProduct?.icon]}
                    <h2>{selectedProduct?.name[selectedLanguage]}</h2>
                    <p>{selectedProduct?.description[selectedLanguage]}</p>
                    <a href={selectedProduct?.cta?.href}>
                        <button>
                            {selectedProduct?.cta?.text[selectedLanguage]}
                        </button>
                    </a>
                </div>
                <div className={styles.businessDivisionProductAboutContainer}>
                    <div className={`${styles.businessDivisionProductImg}`}>
                        {selectedCase?.clientLogo && <img src={selectedCase?.clientLogo}/>}
                    </div>

                    {selectedCase?.data?.map((abt,i) => (
                        <div key={i} className={styles.businessDivisionProductInfo}>
                            <h3>{abt.number}</h3>
                            <p>{abt.text[selectedLanguage]}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );

};

export default Products;
